import { api } from '../apiClient';

export const whitelistService = {
  submitRequest: async (eventSlug: string, formData: FormData): Promise<{
    success: boolean;
    message?: string;
    error?: string;
  }> => {
    const response = await api.post(`/events/${eventSlug}/whitelist-request/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },
};

